<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-sheet>
          <div class="mx-auto pa-8">
            {{ $t("greeting") }}
            {{ this.$store.state.user.profile.first_name }}
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <!-- mini statistic start -->
      <v-col :cols="4" :sm="6" :lg="4">
        <last-feedbacks
        />
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import LastFeedbacks from "../components/card/LastFeedbacks";

export default {
  components: {LastFeedbacks },
  data: () => ({
  }),


  methods: {

  },
};
</script>
